/**
 * Created by pandemio on 3/4/19.
 */
import React from 'react';
import { Redirect } from "react-router-dom";
import { Container, Col, Row} from 'reactstrap';
/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import global from "../translations/global.json";
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import LanguageManager from '../custom-classes/language-manager';
import Footer from './footer/footer';
import NavbarDesktop from './navbar/navbar-desktop-top';
import NavbarMobile from './navbar/navbar-mobile';
import SessionManager from '../custom-classes/session-manager';
import PlanList from './card-list/plan-list';
import ChatClient from './chat/chat-client';
import ApiCalls from '../custom-classes/api-calls';
import Settings from '../custom-classes/settings';
import LiveChat from 'react-livechat';

/**
 * The component (window) to select the plan that the client want to subscribe
 */
class PlanSelect extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage() }
        });
        this.props.addTranslation(global);

        this.state = {
            mobile: false,
            didMount: false,
            planSelected: null,
            chatLiveChatLicense: Settings.CHAT_LIVE_CHAT_LICENSE
        };

        this.selectPlan = this.selectPlan.bind(this)
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        /*this.setState({didMount: true},()=>{
            this.checkIfChatAvailable();
        });*/
    }

    /**
     * Check if the chat is available or not
     */
    checkIfChatAvailable(){
        // This is promise
        let apiCall = ApiCalls.getChatStatus();
        // After the api call, fill the data
        apiCall.then((data)=> {
            this.setState({chatOn: data.IsChatTurnedOn});
        });
    }


    /**
     * To evaluate when the screen size changed
     */
    resize() {
        this.setState({mobile: window.screen.width <= 1024});
    }

    selectPlan(e){
        this.setState({planSelected: e},()=>{
            // If the person is registered already, sent it to the old form

            // If the person is not registered yet, send him to the new form
        });
    }

    /**
     * Renders the landing page
     * @returns {XML}
     */
    render()
    {

        if(this.state.planSelected !== null
            && SessionManager.getSession() !== null
            && typeof SessionManager.getSession() !== 'undefined')
        {

            return (<Redirect push to={{
                pathname: "/subscription-add-new",
                planId: this.state.planSelected
            }}/>);
        }
        else if(this.state.planSelected !== null
            && (SessionManager.getSession() === null
            || typeof SessionManager.getSession() === 'undefined'))
        {
            return (<Redirect push  to={{
                pathname: "/subscribe",
                planId: this.state.planSelected
            }}/>);
        }

        return (
            <div>
                {this.state.mobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding card-white">
                    <Container className="margin-top-mandatory-60">
                        <Row className="centered-text">
                            <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="plan.choose-plan"/>
                                </h1>
                            </Col>
                        </Row>
                        <Row>
                            <PlanList updateParent={this.selectPlan}/>
                        </Row>
                        <LiveChat license={this.state.chatLiveChatLicense} />
                    </Container>
                </div>
                <Footer/>
            </div>
        )
    }

}

export default withLocalize(PlanSelect);